module.exports = __webpack_public_path__ + "img/图3.358420a0.png";